import { format } from "date-fns";

// Always format as 'dd MMM yyyy', e.g., 23 Jun 2025
const DEFAULT_FORMAT = "dd MMM yyyy";
const DEFAULT_FORMAT_WITH_TIME = "dd MMM yyyy, HH:mm";

type FormattedDateProps = {
  value: string | number | Date | undefined;
  className?: string;
  showTime?: boolean;
};

export const FormattedDate = ({
  value,
  className,
  showTime,
}: FormattedDateProps) => {
  if (!value) return null;
  const date =
    typeof value === "string" || typeof value === "number"
      ? new Date(value)
      : value;
  // Check for invalid date
  if (Number.isNaN(date.getTime())) {
    return <span className={className}>-</span>;
  }
  const formatString = showTime ? DEFAULT_FORMAT_WITH_TIME : DEFAULT_FORMAT;
  return <span className={className}>{format(date, formatString)}</span>;
};
